export const RESTFUL = {
  clockInRecords: {
    list: 'rml/admin/clockInRecords',
    read: 'rml/admin/clockInRecords',
    create: 'rml/admin/clockInRecord',
  },
  user: {
    list: 'users',
    read: 'users',
    create: 'users',
  },
  profile: {
    list: 'profiles',
    read: 'rml/admin/profiles',
    update: 'rml/admin/profiles',
    create: 'profiles',
    masterRead: 'rml/master/profiles',
  },
  clientProfile: {
    list: 'rml/admin/memberProfiles',
    read: 'rml/admin/memberProfiles',
    create: 'rml/admin/memberProfiles',
    masterList: 'rml/master/memberProfiles',
  },
  masterProfile: {
    list: 'rml/admin/MasterProfiles',
    read: 'rml/admin/MasterProfiles',
    create: 'rml/admin/MasterProfiles',
    masterList: 'rml/master/MasterProfiles',
    cashierList: 'rml/cashier/MasterProfiles',
  },
  cashierProfile: {
    list: 'rml/admin/CashierProfiles',
    read: 'rml/admin/CashierProfiles',
    create: 'rml/admin/CashierProfiles',
    masterList: 'rml/master/CashierProfiles',
    cashierList: 'rml/cashier/CashierProfiles',
  },
  clinicProfile: {
    list: 'rml/admin/ClinicProfiles',
    read: 'rml/admin/ClinicProfiles',
    create: 'rml/admin/ClinicProfiles',
  },
  adminProfile: {
    list: 'rml/admin/AdminProfiles',
    read: 'rml/admin/AdminProfiles',
    create: 'rml/admin/AdminProfiles',
    staffList: 'rml/staff/AdminProfiles',
  },
  serviceProducts: {
    list: 'rml/admin/serviceProducts',
    read: 'rml/admin/serviceProducts',
    create: 'rml/admin/serviceProducts',
    masterList: 'rml/master/serviceProducts',
  },
  productCategories: {
    list: 'rml/admin/productCategories',
    read: 'rml/admin/productCategories',
    create: 'rml/admin/productCategories',
    masterList: 'rml/master/productCategories',
  },
  leaveApplication: {
    list: 'rml/admin/leaveApplications',
    read: 'rml/admin/leaveApplications',
    create: 'rml/admin/leaveApplications',
    masterList: 'rml/master/leaveApplications',
  },
  booking: {
    list: 'rml/admin/bookings',
    read: 'rml/admin/bookings',
    create: 'rml/admin/bookings',
    masterList: 'rml/master/bookings',
    absentTime: 'rml/admin/booking/absentTime',
  },
  clinicProfile: {
    list: 'rml/admin/ClinicProfiles',
    read: 'rml/admin/ClinicProfiles',
    create: 'rml/admin/ClinicProfiles',
  },
  draftBooking: {
    list: 'rml/admin/draftBookings',
    read: 'rml/admin/draftBookings',
    create: 'rml/admin/draftBookings',
    masterList: 'rml/master/draftBookings',
  },
  timetable: {
    list: 'rml/admin/timetables',
    read: 'rml/admin/timetables',
    create: 'rml/admin/timetables',
  },
  transaction: {
    list: 'rml/admin/transactions',
    read: 'ec/transaction',
    create: 'ec/transaction',
  },
  physicalProducts: {
    list: 'rml/admin/PhysicalProducts',
    read: 'rml/admin/PhysicalProducts',
    create: 'rml/admin/PhysicalProducts',
    masterList: 'rml/master/PhysicalProducts',
  },
  physicalProductOrders: {
    list: 'rml/admin/ProductOrders',
    read: 'rml/admin/ProductOrders',
    create: 'rml/admin/ProductOrders',
  },
  internalPhysicalProducts: {
    list: 'rml/admin/InternalPhysicalProducts',
    read: 'rml/admin/InternalPhysicalProducts',
    create: 'rml/admin/InternalPhysicalProducts',
    masterList: 'rml/master/InternalPhysicalProducts',
  },
  EmployeeContract: {
    list: 'rml/admin/employeeContracts',
    read: 'rml/admin/employeeContracts',
    create: 'rml/admin/employeeContracts',
    masterList: 'rml/master/employeeContracts',
    masterRead: 'rml/master/employeeContracts',
  },
  teachingTasks: {
    list: 'rml/admin/teachingTasks',
    read: 'rml/admin/teachingTasks',
    create: 'rml/admin/teachingTasks',
  },
  payrollRecords: {
    list: 'rml/admin/payrollRecords',
    read: 'rml/admin/payrollRecords',
    create: 'rml/admin/payrollRecords',
    masterList: 'rml/master/payrollRecords',
    masterRead: 'rml/master/payrollRecords',
    update: 'rml/admin/payrollRecords',
  },
  consultationRecords: {
    list: 'rml/admin/consultationRecords',
  },
  posts: {
    list: 'cms/admin/posts',
  },
  pages: {
    list: 'cms/admin/pages',
    read: 'cms/admin/pages',
    create: 'cms/admin/pages',
    update: 'cms/admin/pages',
    delete: 'cms/admin/pages',
  },
  physicalCheckUps: {
    list: 'rml/admin/physicalCheckUps',
  },
  documentation: {
    list: 'rml/admin/documentations',
  },
  billing: {
    list: 'rml/admin/billings',
  },
  billingItem: {
    list: 'rml/admin/billingItems',
  },
  caution: {
    list: 'rml/admin/cautions',
  },
  dosage: {
    list: 'rml/admin/dosages',
  },
  intakeInstruction: {
    list: 'rml/admin/intakeInstructions',
  },
  supplier: {
    list: 'rml/admin/suppliers',
  },
  stock: {
    list: 'rml/admin/stocks',
  },
  labReport: {
    list: 'rml/admin/labReports',
  },
  documentTemplate: {
    list: 'rml/admin/documentTemplates',
  },
  doctorDocument: {
    list: 'rml/admin/doctorDocuments',
  },
  paymentMethod: {
    list: 'rml/admin/paymentMethods',
  },
  medicationFrequency: {
    list: 'rml/admin/medicationFrequencies',
  },
  medicalTerm: {
    list: 'rml/admin/medicalTerms',
  },
  holidays: {
    list: 'rml/admin/holidays',
    read: 'rml/admin/holidays',
    create: 'rml/admin/holidays',
    delete: 'rml/admin/holidays',
    importHK: 'rml/admin/holiday/import-hk',
  },
  qas: {
    list: 'rml/admin/qas',
    read: 'rml/admin/qas',
    create: 'rml/admin/qas',
    update: 'rml/admin/qas',
    delete: 'rml/admin/qas',
  },
};

export const roles = {
  admin: 'admin',
  member: 'rml.member',
  doctor: 'rml.doctor',
  clinicStaff: 'rml.clinicStaff',
  clinic: 'rml.clinic',
};

export const paymentOfCreditCard = {
  ae: 'AE',
  visa: 'Visa',
  master: 'Master',
};

export const paymentOfOthers = {
  cash: 'Cash',
  octopusCard: 'Octopus Card',
  unionPay: 'Union Pay',
  payMe: 'Payme',
  payPal: 'Paypal',
  alipayHK: 'Alipay HK',
  bankTransfer: 'Bank Transfer',
  cheque: 'Cheque',
};

export const physicalProductOrderStatusTextTranslation = {
  pendingPayment: 'Pending Payment',
  pendingDelivery: 'Pending Delivery',
  completed: 'Completed',
  requestCancel: 'Request Cancel',
  cancelled: 'Cancelled',
  expired: 'Expired',
};

export const leaveApplicationOption = {
  ByDate: 'ByDate',
  ByHour: 'ByHour',
};

export const payrollConstant = [
  {
    name: '___basicSalary_of_activatedContract___',

    description: 'The basic salary of activated contract ',
  },
  {
    name: '___diligenceAward_of_activatedContract___',
    description: 'The diligence award of activated contract',
  },
  {
    name: '___yearBonus_of_activatedContract___',
    description: 'The year bonus of activated contract',
  },
  {
    name: '___MPFRate_of_activatedContract___',
    description: 'The MPF Rate of activated contract',
  },
  {
    name: '___annualLeave_selectedMonth_remaining_of_activatedContract___',
    description: 'The annual leave selected month remaining of activated contract',
  },
  {
    name: '___sickLeave_selectedMonth_remaining_of_activatedContract___',
    description: 'The sick leave selected month remaining of activated contract',
  },
  {
    name: '___compensatoryLeave_selectedMonth_remaining_of_activatedContract___',
    description: 'The compensatory leave selected month remaining of activated contract',
  },
  {
    name: '___noPayLeave_selectedMonth_remaining_of_activatedContract___',
    description: 'The no pay leave selected month remaining of activated contract',
  },

  {
    name: '___servicePrice_for_seniority_of_activatedContract_n1___',
    description: 'The service price for seniority of activated contract n1',
  },
  {
    name: '___servicePrice_for_seniority_of_activatedContract_n2___',
    description: 'The service price for seniority of activated contract n2',
  },
  {
    name: '___servicePrice_for_seniority_of_activatedContract_n3___',
    description: 'The service price for seniority of activated contract n3',
  },
  {
    name: '___servicePrice_for_seniority_of_activatedContract_n4___',
    description: 'The service price for seniority of activated contract n4',
  },
  {
    name: '___servicePrice_for_seniority_of_activatedContract_n5___',
    description: 'The service price for seniority of activated contract n5',
  },

  {
    name: '___cashierFeeRate___',
    description: 'The cashier fee rate',
  },
  {
    name: '___specificMasterFee___',
    description: 'The specific master fee',
  },

  {
    name: '___trainingFee_firstMonth___',
    description: 'The training fee first month',
  },
  {
    name: '___trainingFee_afterFirstMonth___',
    description: 'The training fee after first month',
  },

  {
    name: '___headcount_selectedMonth___',
    description: 'The headcount selected month',
  },
  {
    name: '___headcount_selectedMonth_assist___',
    description: 'The headcount selected month assist',
  },
  {
    name: '___headcount_selectedMonth_assist_n1___',
    description: 'The headcount selected month assist n1',
  },
  {
    name: '___headcount_selectedMonth_assist_n2___',
    description: 'The headcount selected month assist n2',
  },
  {
    name: '___headcount_selectedMonth_assist_n3___',
    description: 'The headcount selected month assist n3 ',
  },
  {
    name: '___headcount_selectedMonth_assist_n4___',
    description: 'The headcount selected month assist n4',
  },
  {
    name: '___headcount_selectedMonth_assist_n5___',
    description: 'The headcount selected month assist n5',
  },

  {
    name: '___headcount_selectedMonth_main___',
    description: 'The headcounts selected month main',
  },
  {
    name: '___headcount_selectedMonth_main_n1___',
    description: 'The headcounts selected month main n1',
  },
  {
    name: '___headcount_selectedMonth_main_n2___',
    description: 'The headcounts selected month main n2',
  },
  {
    name: '___headcount_selectedMonth_main_n3___',
    description: 'The headcounts selected month main n3',
  },
  {
    name: '___headcount_selectedMonth_main_n4___',
    description: 'The headcounts selected month main n4',
  },
  {
    name: '___headcount_selectedMonth_main_n5___',
    description: 'The headcounts selected month main n5',
  },

  {
    name: '___headcount_selectedMonth_total___',
    description: 'The headcount selected month total',
  },
  {
    name: '___headcount_selectedMonth_total_n1___',
    description: 'The headcount selected month total n1',
  },
  {
    name: '___headcount_selectedMonth_total_n2___',
    description: 'The headcount selected month total n2',
  },
  {
    name: '___headcount_selectedMonth_total_n3___',
    description: 'The headcount selected month total n3',
  },
  {
    name: '___headcount_selectedMonth_total_n4___',
    description: 'The headcount selected month total n4',
  },
  {
    name: '___headcount_selectedMonth_total_n5___',
    description: 'The headcount selected month total n5',
  },

  {
    name: '___studentCount_selectedMonth_firstMonth_activatedContract___',
    description: 'The student count selected month first month activated contract',
  },
  {
    name: '___studentCount_selectedMonth_secondAndThirdMonth_activatedContract___',
    description: 'The student count selected month second and third month activated contract',
  },
  {
    name: '___studentCount_selectedMonth_total_activatedContract___',
    description: 'The student count selectedMonth_total_activatedContract',
  },
  {
    name: '___ticketPackageSoldCommission_selectedMonth_total___',
    description: 'The ticket package sold commission selected month_total',
  },
  {
    name: '___physicalProductSoldCommission_selectedMonth_total___',
    description: 'The physical product sold commission selected month total',
  },
];

export const consultationResultType = {
  Complaint: '0$complaint',
  Findings: '1$findings',
  Diagnosis: '2$diagnosis',
  Action: '3$action',
};

export const billingPrintType = {
  PrintAddress: '0$PrintAddress',
  PrintPaymentHistory: '1$PrintPaymentHistory',
  PrintBillDate: '2$PrintBillDate',
  GetDiagnosis: '3$GetDiagnosis',
  PatientUndersign: '4$PatientUndersign',
  PrintPrescription: '5$PrintPrescription',
  PrintLaboratory: '6$PrintLaboratory',
  PrintDiscount: '7$PrintDiscount',
};

export const genderType = {
  Male: 'm',
  Female: 'f',
  // Other: 'o',
};

export const documentationType = {
  default: '0$created',
  ClinicUSG: '1$ClinicUSG',
  DoctorCopy: '2$DoctorCopy',
  MedicalRecord: '3$MedicalRecord',
  PatientCopy: '4$PatientCopy',
  Others: '5$Others',
  BillingRecord: '6$BillingRecord',
};

export const supplierType = {
  default: '0$default',
  laboratory: '1$laboratory',
  pharma: '2$pharma',
  courier: '3$courier',
};

export const bookingClinicService = {
  chineseMedical: '0$chineseMedical',
  westernMedicine: '1$westernMedicine',
  hospitalOperation: 'hospitalOperation',
  esdLife: 'esdLife',
  gemvCare: 'gemvCare',
};

// only below bookingClinicService type will need to create consultation
export const BookingClinicServicesWithConsultation = [
  bookingClinicService.westernMedicine,
  bookingClinicService.chineseMedical,
  bookingClinicService.hospitalOperation,
];
export const BookingClinicServicesWithBilling = [
  bookingClinicService.westernMedicine,
  bookingClinicService.chineseMedical,
  bookingClinicService.esdLife,
];

export const productMedicalType = {
  chineseMedical: '0$chineseMedical',
  westernMedicine: '1$westernMedicine',
  sample: '99$sample',
};

export const billingStatus = {
  pending: '0$pending',
  fail: '97$fail',
  completed: '99$completed',
  cancelled: '98$cancelled',
};
export const billingItemType = {
  default: '0$default',
  rml: '1$rml',
  cm: '2$cm',
  cmhc: '3$cmhc',
};

export const bookingSetting = {
  minutesPerSlot: 15,
  newBookingDefaultIntervalInMinutes: 15,
};

export const howToKnowType = {
  Seminar: 'Seminar',
  Yahoo: 'Yahoo',
  Google: 'Google',
  Facebook: 'Facebook',
  NewspapersMagazinesRadio: 'Newspapers/Magazines/Radio',
  FriendsReferral: 'FriendsReferral',
  Others: 'Others',
};

export const documentTemplateTags = {
  date: '{{created_at}}',
  booking: {
    timeText: '{{booking.timeText}}',
    timeText_chinese: '{{booking.timeText_chinese}}',
    dateText: '{{booking.dateText}}',
    dateText_chinese: '{{booking.dateText_chinese}}',
    daytimeAmPmText: '{{booking.daytimeAmPmText}}',
    daytimeAmPmText_chinese: '{{booking.daytimeAmPmText_chinese}}',
  },
  INPUT: {
    referral_name: '{{INPUT.referral_name}}',
    referral_address: '{{INPUT.referral_address}}',
    referral_tel: '{{INPUT.referral_tel}}',
    lmp: '{{INPUT.lmp}}',
    edc: '{{INPUT.edc}}',
    sickLeaveDay: '{{INPUT.sickLeaveDay}}',
    sickLeaveStart: '{{INPUT.sickLeaveStart}}',
    sickLeaveEnd: '{{INPUT.sickLeaveEnd}}',
  },
  patient: {
    name: '{{patient.name}}',
    name_chinese: '{{patient.name_chinese}}',
    gender: '{{patient.gender}}',
    age: '{{patient.age}}',
    hkid: '{{patient.hkid}}',
    phone: '{{patient.phone}}',
    birthdayText: '{{patient.birthdayText}}',
  },
  complaint: '{{complaint}}',
  diagnosis: '{{diagnosis}}',
  action: '{{action}}',
  prescription: '{{{prescription}}}',
  doctor: {
    name: '{{doctor.name}}',
    name_chinese: '{{doctor.name_chinese}}',
    title: '{{doctor.title}}',
    title_chinese: '{{doctor.title_chinese}}',
  },
};

export const productUnit = {
  'Amp(s)': { text: 'Amp(s)', text_chinese: '樽' },
  'Bot(s)': { text: 'Bot(s)', text_chinese: '樽' },
  'Box(s)': { text: 'Box(s)', text_chinese: '盒' },
  'Cap(s)': { text: 'Cap(s)', text_chinese: '粒' },
  'Cartridge(s)': { text: 'Cartridge(s)', text_chinese: '支' },
  g: { text: 'g', text_chinese: '克' },
  ml: { text: 'ml', text_chinese: '毫升' },
  'Pack(s)': { text: 'Pack(s)', text_chinese: '包' },
  'Pc(s)': { text: 'Pc(s)', text_chinese: '片' },
  'Supp(s)': { text: 'Supp(s)', text_chinese: '塞劑' },
  'Tab(s)': { text: 'Tab(s)', text_chinese: '粒' },
  'Tub(s)': { text: 'Tub(s)', text_chinese: '支' },
  'unit(s)': { text: 'unit(s)', text_chinese: '單位' },
  'Vial(s)': { text: 'Vial(s)', text_chinese: '樽' },
};

export const dayOfWeek = {
  Monday: 'Monday',
  Tuesday: 'Tuesday',
  Wednesday: 'Wednesday',
  Thursday: 'Thursday',
  Friday: 'Friday',
  Saturday: 'Saturday',
  Sunday: 'Sunday',
};

export const clientNotificationMessageType = {
  Consultation: 'Consultation',
  Vaccination: 'Vaccination',
  BloodTest: 'BloodTest',
  Custom: 'Custom',
};
export const clientNotificationMessageTemplates = {
  [clientNotificationMessageType.Consultation]:
    '[RML] - Official Message\nWarm Remind, Your Consultation is on *',
  [clientNotificationMessageType.Vaccination]:
    '[RML] - Official Message\nWarm Remind, Your Vaccination is on *',
  [clientNotificationMessageType.BloodTest]:
    '[RML] - Official Message\rWarm Remind, Your Blood Testing is on *',
};

export const clientNotificationStatus = {
  Pending: 'pending',
  Sent: 'sent',
};

// for front-end usage only
export const labReportStatus = {
  Pending: 'Pending',
  Overdue: 'Overdue',
  Received: 'Received',
  Reviewed: 'Reviewed',
  Archived: 'Archived',
};

export const clinicWorkspaces = {
  RML: 'RML',
  CMHC: 'CMHC',
};
export const doctorMedicalTermCategories = {
  action: 'action',
  complaint: 'complaint',
  diagnosis: 'diagnosis',
  findings: 'findings',
};

export const medicalTermTypes = {
  general: 'general',
  doctor: 'doctor',
};

export const labReportType = {
  labItems: 'labItems',
  imagingServices: 'imagingServices',
};

export const billingItemCategory = {
  other: 'other',
  consultation: 'consultation',
  procedure: 'procedure',
  labItems: 'labItems',
  imagingServices: 'imagingServices',
  medication: 'medication',
  ultrasound: 'ultrasound',
};

export const paymentStatus = {
  pending: 'pending',
  paid: 'paid',
  fail: 'fail',
};

export const labelLanguage = {
  en: 'en',
  zhhk: 'zhhk',
};

export const bookingStatus = {
  created: '0$created',
  arrived: '1$arrived',
  requestCancel: '96$requestCancel',
  cancelled: '97$cancelled',
  absent: '98$absent',
  completed: '99$completed',
};

export const bookingApprovalStatus = {
  pending: 'pending',
  approved: 'approved',
  unapproved: 'unapproved',
};

export const bookingReplyStatus = {
  notSend: 'notSend',
  pendingReply: 'pendingReply',
  confirm: 'confirm',
  reject: 'reject',
};

export const holidayType = {
  clinic: 'clinic',
  doctor: 'doctor',
};

export const holidayReason = {
  scheduled: 'scheduled',
  maintenance: 'maintenance',
  adhoc: 'adhoc',
};

export const clinicMembership = {
  default: 'default',
  vip: 'vip',
};

export const maximumUploadFileSizeMB = 50;
